import React, { HTMLProps } from 'react';
import cn from 'classnames';
import Tooltip from '../../../Tooltip/Tooltip';
import styles from './PromoBadge.module.scss?module';
import { ProductSizeInterface } from '../../../../../Interface/ProductSize';

interface PromoBadgeProps extends HTMLProps<HTMLDivElement> {
  productSize: ProductSizeInterface;
  hasStock: boolean;
}

const PromoBadge: React.FC<PromoBadgeProps> = ({
  productSize,
  hasStock,
  className,
  ...props
}) => {
  const promoText = productSize.promo_text;
  const promoPercent = productSize.promo_percent;
  const promoFreeProduct = productSize.promo_free_product_count;
  const promoPlusConditionCount = productSize.promo_plus_condition_count;
  const promoSameProduct = productSize.promo_same_product;
  const promoProductName = productSize.promo_product_name;

  let promoDisplay = '';
  if (promoPlusConditionCount) {
    if (promoSameProduct && promoFreeProduct) {
      promoDisplay = `${promoPlusConditionCount}+${promoFreeProduct}`;
    } else if (promoProductName) {
      promoDisplay = `${promoPlusConditionCount}+${promoProductName}`;
    }
  }

  if (!promoDisplay && promoPercent) {
    promoDisplay = `${promoPercent}%`;
  }

  if (!promoDisplay && promoText) {
    promoDisplay = promoText;
  }

  const hasPromo = !!promoDisplay;

  if (!hasPromo) {
    return null;
  }

  return (
    <Tooltip title={promoText || promoDisplay} placement="top">
      <div className={cn(styles.promoBadge, className)} {...props}>
        {promoDisplay.length > 10
          ? `${promoDisplay.slice(0, 10)}`
          : promoDisplay}
      </div>
    </Tooltip>
  );
};

export default PromoBadge;
